module.exports = __webpack_public_path__ + "img/canva.14b619f4.png";